import type { UiErrorResponse } from "@slfinrtl/ui-bff-routes"
import type { AxiosError } from "axios"
import { isAxiosError } from "axios"

type AxiosErrorWithResponse<T> = AxiosError<T> & Required<Pick<AxiosError<T>, "response">>

export const isUiErrorResponse = (error: unknown): error is AxiosErrorWithResponse<UiErrorResponse> => {
	return isAxiosError(error) && error.response?.data?.traceId
}
